import React from 'react';
import classnames from 'classnames';

import styles from './styles.scss';

class Logo extends React.PureComponent {
  render() {
    const party = this.props.dems ? 'DEMS' : '';
    const page = this.props.page ? this.props.page : '';

    return (
      <h1 className={classnames('logo-container', styles.styles)}>
        <span className={classnames('logo', { dems: this.props.dems })}>
          <span className='year'>{'2O2O'}</span>
          <span className='party'>{party}</span>
          <span className='page'>{page}</span>
        </span>
      </h1>
    );
  }
}

Logo.defaultProps = {
  dems: true,
  page: null,
};

export default Logo;
